import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Footer from '@src/common/Footer';
import { jsonp } from '@ifeng-fe/ui_base';

const Layout = ({ content }) => {
 
    const [modalList, setModalList] = useState([]);
    const [isShowAll, setIsShowAll] = useState(false);

    const fetchData = async () => {
        const data = await jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/doc_9001ab5f5108becd901a9f3ac8d50a4c/info/cb?callback=cb', {
            jsonpCallback: 'cb',
            cache: false,
        });

        if (data.code === 0) {
            setModalList(data.data.content);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const toggleShowAll = () => {
      setIsShowAll(!isShowAll);
    };

    return (
        <div className={styles.layout}>
            <div className={styles.mainImage}>
                <img className={styles.banner} src="https://x0.ifengimg.com/fe/custom/2023_09_18/banner.8c5afd2a7c4a.png" alt="奖牌榜" />

            </div>
            <div className={styles.main}>
                <div className={styles.tableWp}>
                    <table className={styles.table}>
                        <tbody>
                        <tr>
                            <th className={styles.num}>排名</th>
                            <th className={styles.area}>国家/地区</th>
                            <th className={styles.brand}>
                                <div>
                                    <img src="https://x0.ifengimg.com/ucms/2022_03/17E50ECABF7880EC63EB03B039E86E80FF8D77C4_size4_w60_h80.png" alt="金牌" />金牌
                                </div>
                            </th>
                            <th className={styles.brand}>
                                <div>
                                    <img src="https://x0.ifengimg.com/ucms/2022_03/EDE090D64A6887185E563B29261EB42415C91BEB_size4_w60_h80.png" alt="银牌" />银牌
                                </div>
                            </th>
                            <th className={styles.brand}>
                                <div>
                                    <img src="https://x0.ifengimg.com/ucms/2022_03/AF9CE8947D422028BCAB5E81710D2D0EE2EFA1C3_size5_w60_h80.png" alt="铜牌" />铜牌
                                </div>
                            </th>
                            <th className={styles.total}>总数</th>
                        </tr>
                        {
                            (isShowAll ? modalList : modalList.slice(0, 20) ).map((modal, index) => {
                                return (
                                    <tr key={index} className={modal.country === '中国' ? styles.china : ''}>
                                        <td className={styles.num}>{modal.rank}</td>
                                        <td className={styles.area}>
                                            <div>
                                                <img src={modal.img} alt={modal.country} />{modal.country}
                                            </div>
                                        </td>
                                        <td className={styles.brand}>{modal.gold}</td>
                                        <td className={styles.brand}>{modal.silver}</td>
                                        <td className={styles.brand}>{modal.copper}</td>
                                        <td className={styles.total}>{modal.sum}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>

                    </table>
                    {
                        !isShowAll &&
                        <div className={styles.more} onClick={toggleShowAll}>
                            <span>点击查看更多</span>
                            <span className={styles.img} />
                        </div>
                    }
                </div>
            </div>
            <div className={styles.footerBanner}>
                <img src="https://x0.ifengimg.com/fe/custom/2023_09_13/bottombanner.d5ac69795f90.png" alt="" />
            </div>
            <div className={styles.footer}>
                <Footer data={content.footer} />
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
